import { render, staticRenderFns } from "./BoardDrawer.vue?vue&type=template&id=b040433e&scoped=true&"
import script from "./BoardDrawer.vue?vue&type=script&lang=js&"
export * from "./BoardDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BoardDrawer.vue?vue&type=style&index=0&id=b040433e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b040433e",
  null
  
)

export default component.exports